import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "../../Axios";
import { Modal } from "../../ui";

// 🎉 SUCCESS MODAL
const PaymentSuccessModal = ({ onGo }) => {
  return (
    <div className="p-10 text-center">

      {/* Animated check */}
      <div className="flex justify-center mb-6">
        <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center animate-scaleIn">
          <span className="text-4xl text-green-600 animate-pop">✓</span>
        </div>
      </div>

      <h2 className="text-3xl font-bold text-green-700 mb-3 animate-fadeIn">
        Payment Successful!
      </h2>

      <p className="text-gray-600 mb-6 animate-fadeIn delay-200">
        Таны төлбөр амжилттай төлөгдлөө 🎉
      </p>

      <div className="flex justify-center">
      <a
        href={`/courses/${onGo}`}
        className="px-8 py-3 bg-blue-600 text-white rounded-xl shadow-lg inline-block"
      >
        Хичээл рүү очих
      </a>
      </div>
    </div>
  );
};

const CoursePayout = ({
  title,
  amount,
  qr_image,
  invoice_id,
  course_id
}) => {
  const goToCourse = () => {
    console.log("GO:", course_id);
    navigate(`/courses/${course_id}`);
  };
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // 🔥 CHECK PAYMENT
  const handleCheckPayment = async () => {
    try {
      setLoading(true);

      const res = await Axios.post("/payment/confirm", {
        invoice_id: invoice_id, amount:amount 
      });

      console.log("RESPONSE:", res.data);

      if (res.data.status === "PAID") {
        setShowSuccessModal(true);
      } else {
        alert("Төлөгдөөгүй байна");
      }

    } catch (err) {
      console.error("ERROR:", err.response?.data || err);
      alert("Алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 AUTO REDIRECT (2 секунд)
  useEffect(() => {
    if (showSuccessModal) {
      setTimeout(() => {
        navigate(`/courses/${course_id}`);
      }, 2000);
    }
  }, [showSuccessModal]);

  return (
    <>
      <div className="w-full bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 p-8 lg:p-12">
        
        <div className="w-full max-w-7xl mx-auto bg-white/70 backdrop-blur-xl rounded-3xl shadow-2xl flex flex-col lg:flex-row overflow-hidden border border-white/40">
          
          {/* LEFT */}
          <div className="flex-1 flex flex-col items-center justify-center py-12 px-8 relative">
            
            <h2 className="text-4xl font-bold mb-5 text-gray-800">
              Pay with QPay
            </h2>

            <p className="text-lg text-gray-600 text-center mb-8">
              QR уншуулж төлбөрөө хийнэ үү
            </p>

            <div className="bg-white rounded-2xl shadow-xl p-6">
              <img
                src={`data:image/png;base64,${qr_image}`}
                alt="QR"
                className="w-64 h-64 object-contain"
              />
            </div>

            <button
              onClick={handleCheckPayment}
              disabled={loading}
              className="mt-8 px-10 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-xl shadow-lg hover:scale-105 transition font-bold"
            >
              {loading ? "Шалгаж байна..." : "Төлбөр шалгах"}
            </button>
          </div>

          {/* RIGHT */}
          <div className="w-full lg:w-[420px] bg-white/80 px-8 py-10 flex flex-col justify-between">
            
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-800">
                Төлбөрийн хүсэлт
              </h3>

              <div className="flex justify-between mb-6">
                <p className="font-semibold text-xl">
                  {title}
                </p>

                <p className="font-semibold text-xl">
                  {amount?.toLocaleString()}₮
                </p>
              </div>

              <div className="border-t pt-4">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span>{amount?.toLocaleString()}₮</span>
                </div>

                <div className="flex justify-between">
                  <span>Fee</span>
                  <span>0₮</span>
                </div>
              </div>
            </div>

            <div className="border-t pt-4 mt-6 flex justify-between">
              <span className="font-semibold">НИЙТ</span>
              <span className="font-bold text-purple-700">
                {amount?.toLocaleString()}₮
              </span>    
            </div>
          </div>
        </div>
      </div>

      {/* 🎉 SUCCESS MODAL */}
      {showSuccessModal && (
        <Modal visible={true}
        onCancel={() => setShowSuccessModal(false)}>
          <PaymentSuccessModal
            onGo={course_id}
          />
        </Modal>
      )}
    </>
  );
};

export default CoursePayout;